/** `BarcodeDetector` y cámara disponibles (Chrome/Edge en Android; Safari iOS aún no). */
export function cameraScanSupported(): boolean {
  return typeof window !== 'undefined' && 'BarcodeDetector' in window && !!navigator.mediaDevices?.getUserMedia;
}
